import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Device, getNiceDate } from '@iotv/datamodel-core';
import { DeviceTransactionStatus } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import { TransactionStateSteps } from '../../../../../../components/DeviceControl/TransactionStateSteps';
import { AppMainViewContext } from '../../../../../../ContextProviders/AppContextProvider';
const steps = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.ACK,
    DeviceTransactionStatus.DEVICE_ACK,
];
export const DeviceControlTransactionView = ({ dct }) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const { status, timestamp } = dct;
    const [device] = useState(new Device({}));
    return (_jsxs(Stack, { direction: 'row', children: [_jsx(Stack, { direction: 'row', children: _jsx(Typography, { children: getNiceDate(timestamp) }) }), _jsx(Stack, { direction: 'row', children: _jsx(TransactionStateSteps, { device, currentDeviceTransaction: dct, steps, isSmallView }) })] }, dct.sk));
};
